import classNames from 'classnames'
import { Dispatch, SetStateAction, useState } from 'react'
import Modal from '@/stories/components/Common/Modal'

function DeliveryFilters({
  selected,
  setSelected,
  mode,
}: {
  selected: string
  setSelected: Dispatch<SetStateAction<string>>
  mode: 'sips' | 'cnc' | 'intraday' | 'pledge' | 'GTT'
}) {
  return (
    <div className="mt-2 flex flex-wrap gap-2">
      <button
        className={classNames(
          'border-1 rounded-full px-2 py-1 text-sm transition-colors',
          {
            'border-ind-blue text-ind-blue': selected === 'all',
            'border-grey-light text-grey-light': selected !== 'all',
          },
        )}
        onClick={() => setSelected('all')}
      >
        All Orders
      </button>
      <button
        className={classNames(
          'border-1 rounded-full px-2 py-1 text-sm transition-colors',
          {
            'border-ind-blue text-ind-blue': selected === 'completed',
            'border-grey-light text-grey-light': selected !== 'completed',
          },
        )}
        onClick={() => setSelected('completed')}
      >
        Completed Orders
      </button>
      <button
        className={classNames(
          'border-1 rounded-full px-2 py-1 text-sm transition-colors',
          {
            'border-ind-blue text-ind-blue': selected === 'failed',
            'border-grey-light text-grey-light': selected !== 'failed',
          },
        )}
        onClick={() => setSelected('failed')}
      >
        Failed Orders
      </button>
      <button
        className={classNames(
          'border-1 rounded-full px-2 py-1 text-sm transition-colors',
          {
            'border-ind-blue text-ind-blue': selected === 'pending',
            'border-grey-light text-grey-light': selected !== 'pending',
          },
        )}
        onClick={() => setSelected('pending')}
      >
        Pending Orders
      </button>
      {mode !== 'pledge' && (
        <button
          className={classNames(
            'border-1 rounded-full px-2 py-1 text-sm transition-colors',
            {
              'border-ind-blue text-ind-blue': selected === 'cancelled',
              'border-grey-light text-grey-light': selected !== 'cancelled',
            },
          )}
          onClick={() => setSelected('cancelled')}
        >
          Cancelled Orders
        </button>
      )}
    </div>
  )
}

function SIPFilters({
  selected,
  setSelected,
}: {
  selected: string
  setSelected: Dispatch<SetStateAction<string>>
}) {
  return (
    <div className="mt-2 flex flex-wrap gap-2">
      <button
        className={classNames(
          'border-1 rounded-full px-2 py-1 text-sm transition-colors',
          {
            'border-ind-blue text-ind-blue': selected === 'all',
            'border-grey-light text-grey-light': selected !== 'all',
          },
        )}
        onClick={() => setSelected('all')}
      >
        All SIPs
      </button>
      <button
        className={classNames(
          'border-1 rounded-full px-2 py-1 text-sm transition-colors',
          {
            'border-ind-blue text-ind-blue': selected === 'registered',
            'border-grey-light text-grey-light': selected !== 'registered',
          },
        )}
        onClick={() => setSelected('registered')}
      >
        Registered SIPs
      </button>
      <button
        className={classNames(
          'border-1 rounded-full px-2 py-1 text-sm transition-colors',
          {
            'border-ind-blue text-ind-blue': selected === 'paused',
            'border-grey-light text-grey-light': selected !== 'paused',
          },
        )}
        onClick={() => setSelected('paused')}
      >
        Paused SIPs
      </button>
      <button
        className={classNames(
          'border-1 rounded-full px-2 py-1 text-sm transition-colors',
          {
            'border-ind-blue text-ind-blue': selected === 'failed',
            'border-grey-light text-grey-light': selected !== 'failed',
          },
        )}
        onClick={() => setSelected('failed')}
      >
        Failed SIPs
      </button>
      <button
        className={classNames(
          'border-1 rounded-full px-2 py-1 text-sm transition-colors',
          {
            'border-ind-blue text-ind-blue': selected === 'pending',
            'border-grey-light text-grey-light': selected !== 'pending',
          },
        )}
        onClick={() => setSelected('pending')}
      >
        Pending SIPs
      </button>
      <button
        className={classNames(
          'border-1 rounded-full px-2 py-1 text-sm transition-colors',
          {
            'border-ind-blue text-ind-blue': selected === 'cancelled',
            'border-grey-light text-grey-light': selected !== 'cancelled',
          },
        )}
        onClick={() => setSelected('cancelled')}
      >
        Cancelled SIPs
      </button>
    </div>
  )
}

export default function INStocksTransactionsFilterModal({
  showModal,
  onClose,
  mode,
  setFilter,
  filter,
}: {
  showModal: boolean
  onClose: () => void
  mode: 'sips' | 'cnc' | 'intraday' | 'pledge' | 'GTT'
  setFilter: Dispatch<
    SetStateAction<{
      type: string | null
    }>
  >
  filter: {
    type: string | null
  }
}) {
  const [selected, setSelected] = useState(filter.type ?? '')
  return (
    <Modal
      showModal={showModal}
      onClose={() => onClose()}
      bodyClassName="max-w-lg lg:max-w-1/3"
      childrenClassName="!p-0 bg-ind-white"
    >
      <div className="flex flex-col justify-center">
        <p className="text-grey-dark mb-3 px-3 pt-3 text-left text-lg font-medium">
          Filters
        </p>
        <div className="px-3">
          <p className="text-grey text-sm">By Type</p>
          {(mode === 'cnc' ||
            mode === 'intraday' ||
            mode === 'pledge' ||
            mode === 'GTT') && (
            <DeliveryFilters
              setSelected={setSelected}
              selected={selected}
              mode={mode}
            />
          )}
          {mode === 'sips' && (
            <SIPFilters setSelected={setSelected} selected={selected} />
          )}
        </div>
        <div className="shadow-two mt-5 flex items-center justify-between rounded-b-xl px-20 py-5">
          <span
            className="text-ind-blue w-1/2 cursor-pointer text-center text-base"
            onClick={() => {
              setFilter({ type: 'all' })
              void onClose()
            }}
          >
            Clear All
          </span>
          <button
            className="bg-green text-spl-white shadow-one  w-1/2 rounded-full py-2 text-center"
            onClick={() => {
              setFilter({ type: selected })
              void onClose()
            }}
          >
            Apply
          </button>
        </div>
      </div>
    </Modal>
  )
}
